var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    enableBackground: "new 0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M42.2,50.7c2.1,4.5,4.6,8.9,7.9,12.6c1.2-2.2,2.1-4.5,3.1-6.8c3.9-10.2,6-21,7.4-31.7 c1-8.1,1.7-16.4,1.6-24.5C52.9,0.5,43.4,2.9,35,7.1c-0.2,0.1-0.5,0.3-0.7,0.5c-0.2,1.6,0,3.3-0.1,4.9 C34.5,25.5,36.8,38.7,42.2,50.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M72.6,50.2c1.4,4.4,3,8.9,5.2,13c2.4-2.8,4.4-5.9,6.2-9.1c5.3-9.9,8.1-21.1,9.2-32.3 c0.4-4.7,0.7-9.5,0.5-14.2c-2.1-1.3-4.5-2.2-6.7-3.2c-6.8-2.6-14-4-21.3-4.2c-0.1,4,0.1,8,0.4,11.9C67,25,68.8,37.8,72.6,50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M18.8,56.5c4.8-7.1,7.7-15.3,9.6-23.6C30.1,25.2,31,17.3,31,9.4c-0.5,0.2-1,0.5-1.4,0.8 c-8.1,5.2-15.1,12.2-20.2,20.5c-7.5,12.1-10.7,27-8.9,41.1C8,68.7,14.3,63.1,18.8,56.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M120.5,34.2c-4.5-8.6-11.1-16.2-19-21.9c-1.5-1-2.9-2.1-4.5-2.9c0,6.3,0.6,12.7,1.7,19 c1.7,9.5,4.7,19,9.9,27.1c4.5,7.1,11,13.1,18.9,16.3C129.1,59,126.6,45.6,120.5,34.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M44.8,74.9c-0.4-0.8-1.2-1.4-1.8-2.1c-2.7-3.1-4.9-6.6-6.8-10.2c-1.5-2.9-2.6-6-3.6-9 c-0.6,0.9-0.9,1.9-1.2,2.9c-1.8,5.1-4.4,10-7.7,14.3C18.6,77.4,11.8,83,3.9,85.9c0.1,0.6,0.3,1.2,0.5,1.7c2,5,4.6,9.8,7.8,14.1 c1.3,1.6,2.5,3.4,4,4.8c1-0.3,1.8-0.9,2.7-1.4c9.6-6.2,17.2-15.2,23-24.9C43,78.5,44.1,76.8,44.8,74.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M64.8,56.9c-0.3-1.1-0.2-2.3-0.9-3.2c-0.7,0.9-0.6,2.2-0.9,3.2c-2.1,10.8-5.3,21.5-9.6,31.6 c-4.9,11.4-11.3,22.4-20.3,31.1c-0.4,0.5,0.5,0.7,0.8,0.9c9,4.7,19.2,7.3,29.4,7.4c10.9,0.1,22-2.6,31.5-8 c-9-8.9-15.7-20-20.6-31.6C70.2,78.2,66.9,67.7,64.8,56.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M96.5,56.4c-0.3-0.9-0.5-1.9-1.1-2.7c-0.6,1-0.9,2.2-1.3,3.3c-2.4,6.5-6,12.5-10.7,17.6 c-0.5,0.4-0.1,0.9,0.1,1.3c2.1,4,4.5,7.8,7.1,11.4c5.1,6.9,11.2,13.2,18.5,18c0.8,0.5,1.6,1.1,2.5,1.3c0.7-0.5,1.2-1.3,1.7-1.9 c3.4-4.1,6.2-8.6,8.5-13.4c0.8-1.7,1.6-3.5,2.1-5.3c-4.3-1.6-8.2-3.9-11.7-6.8C105,73.2,99.6,65.2,96.5,56.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBay);
export default __webpack_public_path__ + "static/media/bay.fd622c88f400d10ed06ee66ba55b2b3f.svg";
export { ForwardRef as ReactComponent };